import React from 'react';
import styled from 'styled-components'

const Btn = styled.span`
  .btn.rounded {
    border-radius: 50px!important;
  }
  .btn-sm {
    font-size: .7rem;
    padding: .2rem .5rem;

    i {
      font-size: .7rem;
    }
  }
`;

const Button = ({ 
    isLoading = false,
    disabled = false,
    size = 'normal', // small, normal (default), large
    color = 'dark-blue', // dark-blue (default), light-blue-dark, orange

    // variant = 'solid', // solid (default), outline
    // style = 'square', // square (default), round

    style = 'solid', // solid (default), outline
    round = false,
    width = 'auto', // auto (default), 100
    icon = '', // FontAwesome icon class, example: fa-regular fa-circle-xmark
    text = '', // Button text
    type = 'button', // button (default), submit, link
    onClickFunction = () => {},
    href = '',
    part = '',
    addClass = '',
    target = '_blank',
    className = '',
    loadingWithText = false
  }) => {

  let sizeClass = '';
  let colorClass = ' btn-';

  switch(size){
    case 'small':
      sizeClass += ' btn-sm'
    case 'large':
      sizeClass += ' btn-lg'
  }

  switch(style){
    case 'outline':
      colorClass = ' btn-outline-'
  }

  switch(color){
    case 'light':
      colorClass += 'light text-gc-dark-blue';
      break;
    case 'dark-blue':
      colorClass += 'gc-dark-blue';
      break;
    case 'light-blue-dark':
      colorClass += 'gc-light-blue-dark';
      break;
    case 'orange':
      colorClass += 'gc-orange';
      break;
    case 'danger':
      colorClass += 'danger';
      break;
  }

  switch(width){
    case '100':
      sizeClass += ' w-100'
  }

  let iconRender = '';
  if(icon){iconRender = <i className={icon + (text != '' ? (size == 'small' ? " mr-1" : " mr-1") : '')}></i> }

  let classRender = "btn font-weight-bold " + (className ?? '') + sizeClass + colorClass + (round ? ' rounded' : "") + (disabled ? " disabled" : "") + ' ' + addClass;

  let content = isLoading ? (
    <>
      <div 
        className="spinner-border mr-1" 
        role="status" 
        style={{height: "25px", width: "25px"}}
      >
        <span className="sr-only">Loading...</span>
      </div>
      {(loadingWithText && text) && (
        <span className="pl-1">{text}</span>
      )}
    </>
  ) : ( 
    <>
      {text && <span>{text}</span>}
    </>
  );

  if(type == "button" || type == "submit"){
    return <Btn>
      <button
        onClick={(e) => onClickFunction(e)}
        className={classRender}
        type={type}
        disabled={disabled}
      > 
        {iconRender} {content}
      </button>
    </Btn> 
  }

  if(type == "link"){
    return <Btn>
      <a 
        href="#"
        data-target={href}
        data-part={part}
        className={classRender + " get_part_link js-nav"}
        disabled={disabled}
      > 
        {iconRender} {content}
      </a>
    </Btn> 
  }

  if(type == "a"){
    return <Btn>
      <a 
        href={href}
        className={classRender}
        disabled={disabled}
        target={target}
      > 
        {iconRender} {content}
      </a>
    </Btn> 
  }
}

export default Button